import { render, staticRenderFns } from "./Statements.vue?vue&type=template&id=a3b830e2"
import script from "./Statements.vue?vue&type=script&lang=js"
export * from "./Statements.vue?vue&type=script&lang=js"
import style0 from "./Statements.vue?vue&type=style&index=0&id=a3b830e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports